import { Action, From, Message } from './vitrual-assistant.type';
import {
    AI_ASSISTANT_ALLOWED_FILE_EXTENSIONS,
    AI_ASSISTANT_MAX_FILE_SIZE_BYTES,
    AI_ASSISTANT_UPLOAD_FILE_MIME_TYPES,
} from './virtual-assistant.constants';

export const createMessage = (from: From, text: string, action?: Action): Omit<Message, 'id'> => {
    return { from, text, action };
};

export const fromUser = (text: string) => createMessage(From.USER, text);

export const fromAssistant = (text: string, action?: Action) =>
    createMessage(From.ASSISTANT, text, action);

export const delay = async (delay: number) => new Promise((res) => setTimeout(res, delay));

export const getFileExtension = (fileName: string): string => {
    const parts = fileName.split('.');
    return parts.length > 1 ? parts.pop()?.toLowerCase() ?? '' : '';
};

export const isAllowedAiAssistantFile = (file: File) => {
    const extension = getFileExtension(file.name);
    const isAllowedExtension = Boolean(
        extension && AI_ASSISTANT_ALLOWED_FILE_EXTENSIONS.includes(extension)
    );

    if (!isAllowedExtension) return false;
    if (!file.type) return true;

    return AI_ASSISTANT_UPLOAD_FILE_MIME_TYPES.includes(file.type);
};

export const isAiAssistantFileSizeAllowed = (file: File) => {
    return file.size <= AI_ASSISTANT_MAX_FILE_SIZE_BYTES;
};

export const formatFileSize = (size: number) => {
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / 1024 / 1024).toFixed(1)} MB`;
};
